import { ComponentType } from 'react';
import { BlockNode, BlocksTree, Subtree } from '@finder/ui-blocks.commons';
import blocksMap from './mappers';
import { getPostContentComponent } from './mappers/postContent';
import { TraceType } from './types';
interface ContentProps {
  blocksTree: BlocksTree;
  TraceComponent?: ComponentType<TraceType>;
}

export default function Content({ blocksTree, TraceComponent }: ContentProps): JSX.Element {
  // blocksTree represents the JSON tree data provided from WP
  const rootBlock = blocksTree.root;

  return (
    <BlockNode
      index={0}
      blockName={rootBlock.value.name}
      blocksMap={blocksMap}
      postContent={getPostContentComponent}
      TraceComponent={TraceComponent}
      {...rootBlock.value.attrs}
    >
      {rootBlock.subtree as Subtree[]}
    </BlockNode>
  );
}
